import { useEffect, useState } from "react";
import { fetchPublicProviders, type PublicProvider } from "../../api/publicProviders";

/**
 * The AI tools the portal covers, for the signed-out page to name. Null until they have loaded, and stays null if they cannot be, so the
 * page says nothing about which tools there are rather than guess.
 *
 * @returns The providers, or null.
 */
export function usePublicProviders(): PublicProvider[] | null {
  const [providers, setProviders] = useState<PublicProvider[] | null>(null);

  useEffect(() => {
    let active = true;
    void fetchPublicProviders().then((result) => {
      if (active && result.kind === "ok" && result.response.length > 0) {
        setProviders(result.response);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return providers;
}
